<script setup>
import { swalError } from '@/helper';
import { ref } from 'vue'
import VuePdfEmbed, { useVuePdfEmbed } from 'vue-pdf-embed'
import Loading from '@/components/loading.vue';
// import 'vue-pdf-embed/dist/styles/annotationLayer.css'
// import 'vue-pdf-embed/dist/styles/textLayer.css'
const props = defineProps({
  pdf_url:{
    type: String,
    default: 'https://cdn.syncfusion.com/content/pdf/pdf-succinctly.pdf'
  },
  controls: {
    type: Array,
    default: ['zoom', 'switchpage']
  }
})

const { doc } = useVuePdfEmbed({ source: props.pdf_url })
const pageCount = ref(0)
const page = ref(1)
const isLoading = ref(true)
function handleDocumentLoad({numPages}) {
  isLoading.value = false
  pageCount.value = numPages
}
function handleDocumentError(error){
  swalError(error,true)
}
function nextPage(){
  if (page.value < pageCount.value){
    page.value++
  }else{
    swalError('No more page')
  }
}
function prevPage(){
  if (0 < page.value){
    page.value--
  }else{
    swalError('No negative page exist')
  }
}
</script>

<template>
  <Loading v-if="isLoading" />

  <div v-if="!isLoading" class="d-flex align-items-center justify-content-center">
    <button class="btn btn-light-primary" @click="prevPage">
      Prev
    </button>
    <p class="mb-0 mx-2">{{ page }} / {{ pageCount }}</p>
    <button class="btn btn-light-primary" @click="nextPage">
      Next
    </button>
  </div>
  <VuePdfEmbed 
    :source="doc" 
    :page="page" 
    :scale="scale"
    @loaded="handleDocumentLoad" 
    @loading-failed="handleDocumentError"
    @rendering-failed="handleDocumentError"
  />

</template>